module.exports = __webpack_public_path__ + "static/media/complex-4.f7264971.webp";